import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import store, { persistedStore } from "./redux";
import MainContainer from "./router";
import { PersistGate } from "redux-persist/integration/react";
import { SentryErrorBoundary } from "./sentry";
import { installAndroidKeyboardHeightBridge } from "./utils/androidKeyboardHeightBridge";

installAndroidKeyboardHeightBridge();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <SentryErrorBoundary
    fallback={({ error }) => <div>An error has occurred</div>}
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <MainContainer />
      </PersistGate>
    </Provider>
  </SentryErrorBoundary>
);
